import React from 'react';
import './ServicesPage.css';
import { useLanguage } from './i18n/LanguageContext';

const ServicesPage = ({ onNavigateToDashboard }) => {
  const { t } = useLanguage();
  const services = [
    {
      id: 1,
      title: 'Airport Transfer',
      description: 'Premium terminal transfers with dedicated meet & greet service.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 16V14L13 9V7C13 6.45 12.55 6 12 6C11.45 6 11 6.45 11 7V9L3 14V16L11 13.5V19L9 20.5V22L12 21L15 22V20.5L13 19V13.5L21 16Z"
            fill="currentColor"
          />
        </svg>
      ),
      iconColor: '#4A90E2'
    },
    {
      id: 2,
      title: 'Local Sightseeing',
      description: 'Personalized tours of landmarks with professional local insights.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M12 2L2 7L12 12L22 7L12 2Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M2 17L12 22L22 17"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2 12L12 17L22 12"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      iconColor: '#666666'
    },
    {
      id: 3,
      title: 'Outstation',
      description: 'Luxury intercity travel for weekend getaways and business trips.',
      icon: (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3 12L5 10M5 10L12 3L19 10M5 10V20C5 20.5523 5.44772 21 6 21H9M19 10L21 12M19 10V20C19 20.5523 18.5523 21 18 21H15M9 21C9.55228 21 10 20.5523 10 20V16C10 15.4477 10.4477 15 11 15H13C13.5523 15 14 15.4477 14 16V20C14 20.5523 14.4477 21 15 21M9 21H15"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
      iconColor: '#4A90E2'
    }
  ];

  const handleTakeMeHome = (onNavigate) => {
    // Navigate to dashboard
    if (onNavigate) {
      onNavigate();
    }
  };

  return (
    <div className="services-page">
      <div className="services-content">
        <header className="services-header">
          <h1 className="services-title">{t('Your private fleet')}</h1>
          <p className="services-subtitle">
            Exclusively curated transport for your hotel stay.
          </p>
        </header>

        <div className="services-list">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className="service-icon-container" style={{ color: service.iconColor }}>
                {service.icon}
              </div>
              <div className="service-info">
                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <button className="take-me-home-btn" onClick={() => handleTakeMeHome(onNavigateToDashboard)}>
          Take me home
        </button>
      </div>
    </div>
  );
};

export default ServicesPage;
